if (!customElements.get('deferred-media')) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      this.templateLoaded = false;
      this.handlePosterClick = this.handlePosterClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      const posterButton = this.querySelector('.deferred-media__poster');

      if (posterButton) {
        posterButton.addEventListener('click', this.handlePosterClick);
        posterButton.addEventListener('keydown', this.handleKeydown);
      }

      // Optional autoload when visible: opt-in with data-load-on-visible="true"
      const shouldLoadOnVisible = this.getAttribute('data-load-on-visible') === 'true';
      if (shouldLoadOnVisible && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadContent();
                io.disconnect();
              }
            });
          },
          { rootMargin: '0px', threshold: 0 }
        );
        io.observe(this);
      }
    }

    handlePosterClick(event) {
      event.preventDefault();
      this.loadContent();
    }

    handleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.loadContent();
      }
    }

    loadContent() {
      if (this.templateLoaded) return;

      const template = this.querySelector('template');
      if (!template || !template.content) return;

      this.templateLoaded = true;
      this.setAttribute('loaded', 'true');

      // Replace poster with actual media
      const fragment = template.content.cloneNode(true);
      const poster = this.querySelector('.deferred-media__poster');
      if (poster) poster.remove();
      this.appendChild(fragment);

      // Try to autoplay if it's a native <video>
      const video = this.querySelector('video');
      if (video) {
        try {
          video.play().catch(() => {});
        } catch (e) {}
      }

      // YouTube/Vimeo iframes already include autoplay=1 in src in our liquid
    }
  }

  customElements.define('deferred-media', DeferredMedia);
}
